import { useReviewCreationData } from 'reducers/reviewCreationSlice';

import { FormVisibilitySettings } from 'assets/assetsV1/iconComponents';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { Divider } from 'uiToolkitV1/Divider';
import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';

import { useTemplateMetadata } from '../../Hooks/dataHooks/formFillingsDataHooks';
import { ManagerReviewerSettings } from './ManagerReviewerSettings';
import { PeerReviewerSettings } from './PeerReviewerSettings';
import { SelfReviewerSettings } from './SelfReviewerSettings';

export const FormFillingVisibility = ({ feedbackFormId }: { feedbackFormId: number }) => {
  const { reviewCycleId } = useReviewCreationData();
  const selfTemplateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.SELF,
  });
  const managerTemplateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.MANAGER,
  });
  const peerMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.PEER,
  });
  const upwardMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.UPWARD,
  });

  const reviewers = [];
  if (selfTemplateMetadata) {
    reviewers.push(<SelfReviewerSettings feedbackFormId={feedbackFormId} />);
  }
  if (managerTemplateMetadata) {
    reviewers.push(<ManagerReviewerSettings feedbackFormId={feedbackFormId} />);
  }
  if (peerMetadata || upwardMetadata) {
    reviewers.push(<PeerReviewerSettings feedbackFormId={feedbackFormId} />);
  }

  return (
    <ExpandablePaper>
      <ExpandablePaperHeader
        title="Set the visibility of scores shown in the review form for different types of reviewers"
        leftIconComponent={<FormVisibilitySettings boxSize="24px" color="icon.g2" />}
      />
      <ExpandablePaperBody>
        {reviewers.map((reviewer, i) => (
          <>
            {reviewer}
            {i !== reviewers.length - 1 && <Divider my={3} />}
          </>
        ))}
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
